module.exports = __webpack_public_path__ + "img/1541866748.bb26ddb8.jpg";